<template>
  <b-overlay
    :show="isLoading"
    :variant="overlayVariant"
    :opacity="overlayOpacity"
    :blur="overlayBlur"
    :rounded="overlayRounded"
    :no-fade="disableFade"
    :z-index="zIndexValue"
    :no-wrap="noWrapMode"
    :fixed="useFixedPositioning"
  >
    <slot></slot>
    <template #overlay>
      <div class="d-flex flex-column align-items-center">
        <template v-if="!hideDefaultSpinner">
          <b-spinner
            :type="spinnerType"
            :variant="spinnerVariant"
            :small="smallSpinner"
            :label="spinnerLabel"
          ></b-spinner>
        </template>
        <slot name="overlay-content">
          <span v-if="message" class="mt-2">{{ message }}</span>
        </slot>
      </div>
    </template>
  </b-overlay>
</template>

<script>
export default {
  name: 'Overlay',
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    overlayVariant: {
      type: String,
      default: 'light',
    },
    overlayOpacity: {
      type: [Number, String],
      default: 0.85,
      validator: (value) => {
        const num = Number(value);
        return !isNaN(num) && num >= 0 && num <= 1;
      },
    },
    overlayBlur: {
      type: String,
      default: '2px',
    },
    overlayRounded: {
      type: [Boolean, String],
      default: false,
    },
    spinnerType: {
      type: String,
      default: 'border',
    },
    spinnerVariant: {
      type: String,
      default: null,
    },
    smallSpinner: {
      type: Boolean,
      default: false,
    },
    spinnerLabel: {
      type: String,
      default: 'Loading...',
    },
    hideDefaultSpinner: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: '',
    },
    disableFade: {
      type: Boolean,
      default: false,
    },
    zIndexValue: {
      type: [Number, String],
      default: 10,
    },
    noWrapMode: {
      type: Boolean,
      default: false,
    },
    useFixedPositioning: {
      type: Boolean,
      default: false,
    }
  },
};
</script>
